
























































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import NotificationsBloc from '@/components/Dashboard/NotificationsBloc.vue' // @ is an alias to /src
import Profil from '@/components/Dashboard/Profil.vue' // @ is an alias to /src
import Planning from '@/components/Dashboard/Planning.vue' // @ is an alias to /src
import Blog from '@/components/Dashboard/Blog.vue' // @ is an alias to /src
import blocGauche from '@/components/ProgImmo/blocGauche.vue' // @ is an alias to /src
import blocMap from '@/components/ProgImmo/blocMap.vue' // @ is an alias to /src
import CapacitesSite from '@/components/ProgImmo/CapacitesSite.vue' // @ is an alias to /src
import Partenaires from '@/components/ProgImmo/Partenaires.vue' // @ is an alias to /src
import Prestations from '@/components/ProgImmo/Prestations.vue' // @ is an alias to /src
import Progope from '@/components/ProgImmo/Progope.vue' // @ is an alias to /src
import References from '@/components/ProgImmo/References.vue' // @ is an alias to /src
import Groupe from '@/components/Groups/Groupe.vue' // @ is an alias to /src
import AperProfil from '@/components/Group/AperProfil.vue' // @ is an alias to /src
import Membres from '@/components/Group/Membres.vue' // @ is an alias to /src
import Messagerie from '@/components/Group/Messagerie.vue' // @ is an alias to /src
import InfosGroup from '@/components/Group/InfosGroup.vue' // @ is an alias to /src
import Prog from '@/components/Group/Prog.vue' // @ is an alias to /src
import Pieces from '@/components/Profil/Pieces.vue' // @ is an alias to /src

@Component({
    components: {
        NotificationsBloc,
        Profil,
        Planning,
        Blog,
        blocGauche,
        blocMap,
        CapacitesSite,
        Partenaires,
        Prestations,
        Progope,
        References,
        Groupe,
        AperProfil,
        Membres,
        Messagerie,
        InfosGroup,
        Prog,
        Pieces,
    },
})
export default class Library extends Vue {
    // @Prop() private title!: string;
}
